import script from "./SkillbusinesstypeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillbusinesstypeView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillbusinesstypeView.vue?vue&type=style&index=0&id=30fa4b72&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30fa4b72"]])

export default __exports__